import React from "react";

interface AgentIconProps {
  size?: number;
}

/**
 * Small agent identity mark — a minimal spark/circuit symbol.
 * Used across Whisper, Toast, Dialog to visually identify agent messages.
 */
export default function AgentIcon({ size = 12 }: AgentIconProps): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      className="shrink-0"
      style={{ color: "var(--c-primary)" }}
    >
      {/* Spark mark */}
      <circle cx="6" cy="6" r="2" fill="currentColor" />
      <path
        d="M6 1v2M6 9v2M1 6h2M9 6h2"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
